module.exports = __webpack_public_path__ + "img/shadow_left.9ef11526.png";